import { render, staticRenderFns } from "./lectureList.vue?vue&type=template&id=4c6fc799&scoped=true&"
import script from "./lectureList.vue?vue&type=script&lang=js&"
export * from "./lectureList.vue?vue&type=script&lang=js&"
import style0 from "./lectureList.vue?vue&type=style&index=0&id=4c6fc799&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6fc799",
  null
  
)

export default component.exports